import { render, staticRenderFns } from "./CommonTopItems.vue?vue&type=template&id=a515f044&scoped=true&"
import script from "./CommonTopItems.vue?vue&type=script&lang=js&"
export * from "./CommonTopItems.vue?vue&type=script&lang=js&"
import style0 from "./CommonTopItems.vue?vue&type=style&index=0&id=a515f044&prod&scoped=true&lang=css&"
import style1 from "./CommonTopItems.vue?vue&type=style&index=1&id=a515f044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a515f044",
  null
  
)

export default component.exports